import Header from '@propertypal/shared/src/resources/images/pn-devs/regent-park/header.png';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevHeaderImg, DevUnorderdList } from './DevelopmentContent.style.pn';

interface RegentParkContentProps {}

const RegentParkContent: React.FC<RegentParkContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.textDark,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="regent-park-content">
      <DevelopmentContent bg="#ffd500">
        <DevelopmentSection narrow>
          <DevHeaderImg src={Header.src} alt="Regent Park Development" />
          <DevUnorderdList {...textProps}>
            <li>**Now On Release</li>
            <li>SPECIFICATION</li>
            <li>Kitchen &amp; Utility</li>
            <li>High quality units with choice of door, worktop and handle</li>
            <li>
              Integrated appliances to include gas hob, electric oven, extractor fan, fridge/freezer &amp; dishwasher
            </li>
            <li>LED under lighting to kitchen units</li>
            <li>Recessed LED down lighters to ceilings in kitchen</li>
            <li>Porcelain floor tiling</li>
            <li>Ceramic wall tiling between kitchen units</li>
            <li>Integrated washing machine where no utility</li>
            <li>Plumbing for washing machine in utility where applicable</li>
            <li>Bathroom, En suites &amp; WC</li>
            <li>Contemporary white sanitary ware with chrome fittings</li>
            <li>Full height porcelain tiling to shower enclosure in main bathroom where applicable</li>
            <li>Chrome towel radiators in bathroom and ensuite</li>
            <li>Recessed LED down lighters to ceilings in bathroom and ensuite</li>
            <li>Choice of porcelain partial wall tiling to bathroom and ensuite</li>
            <li>Choice of porcelain floor tiles to bathroom and ensuite</li>
            <li>Dual drencher showerhead to ensuite</li>
            <li>Choice of ceramic splashback to WC sink</li>
            <li>Internal Features</li>
            <li>Internal décor, walls and ceilings painted from a palette of selected colours (1 colour throughout)</li>
            <li>Choice of stove with granite or slate hearth (Except The Ladywell)</li>
            <li>Mains supply smoke &amp; carbon monoxide detectors</li>
            <li>Moulded skirting and architraves with painted finish</li>
            <li>Painted internal doors with quality ironmongery</li>
            <li>Carpets to lounge, bedrooms, stairs and landings with underlay</li>
            <li>Porcelain tiles to hallway</li>
            <li>Comprehensive range of electrical sockets, switches, TV and telephone points</li>
            <li>Wiring for future satellite point</li>
            <li>Gas fired central heating</li>
            <li>Integral alarm system</li>
            <li>Energy efficient fittings/bulbs to all rooms</li>
            <li>High thermal insulation and energy efficiency rating</li>
            <li>External Features</li>
            <li>Timber frame construction (Except the Ladywell)</li>
            <li>Traditional Masonry Construction to the Ladywell</li>
            <li>Soft landscaping to front gardens (where applicable).</li>
            <li>Front gardens to be turfed</li>
            <li>Rear gardens rotovated and seeded in next planting season - weather dependant.</li>
            <li>Bitmac driveway</li>
            <li>Tobermore pavers to front</li>
            <li>uPVC double glazed windows and uPVC rear door with lockable system</li>
            <li>Composite front door with secure multi locking system</li>
            <li>Outside water tap</li>
            <li>External socket</li>
            <li>External lighting to front and rear doors</li>
            <li>10 year NHBC structural warranty</li>
          </DevUnorderdList>
          <Text {...textProps}>
            Sitting proudly on the northernmost tip of the rolling Strangford Lough landscape, Regent Park is another
            prestigious member of the growing family of outstanding move-in-ready houses from Hilmark Homes. A mere 10
            miles from the heart of Belfast on the Ards Peninsula, we&apos;ve created a unique development that allows
            you to seamlessly balance career, family and recreation for the very best of Northern Ireland living.
            It&apos;s the exceptional mix of quality build and traditional living in a highly desirable location that
            lifts Regent Park far above the rest. Surrounding Area - BT23. Overlooked by the iconic Scrabo Tower and
            only minutes from unforgettable settings such as the UNESCO world heritage site Mount Stewart and Grey
            Abbey, home to world class antique shops, Newtownards is large town with a little bit of everything. Enjoy
            the peaceful solitude as you walk along the shores of Strangford Lough, join the crowd and cheer on the
            local rugby, cricket and football teams or meet family and friends at one of the many restaurants, bars and
            pubs. And with a wealth of shopping, excellent schools and historic churches, there&apos;s something to make
            everyone feel right at home. Hilmark Homes Every Regent Park home is designed to blend naturally with its
            environment and complement the surrounding architecture.. Featuring truly unique designs, your future
            detached home is constructed by skilled local craftsmen using carefully selected materials. And though we
            meticulously consider every element, we&apos;re unique in that we encourage you to add your personal touch
            to the finished design. With Hilmark Homes we promise your new home will always be unique, always considered
            and always built for you. Location Regent Park offers a world of high-class traditional living with nearby
            historic landmarks, churches and schools, as well as sports clubs, modern amenities and easy access to
            Belfast and Bangor.
          </Text>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default RegentParkContent;
